module.exports = __webpack_public_path__ + "media/images/partner-alt-6-8f938764b26008f679d54d256f4311b5.png";